function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
const RecipesIcon = forwardRef(function(_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    rest = _objectWithoutProperties(_ref, ['color', 'size']);

  return /*#__PURE__*/ React.createElement(
    'svg',
    _extends(
      {
        ref: ref,
        width: size,
        height: size,
        viewBox: '0 0 12 12',
        fill: color,
        xmlns: 'http://www.w3.org/2000/svg',
        stroke: 'none',
      },
      rest
    ),
    /*#__PURE__*/ React.createElement('path', {
      d:
        'M11.4947 0.112732C11.0652 0.0394777 10.6303 0.00177086 10.1944 2.58106e-06C8.70743 -0.00120451 7.25143 0.421002 6 1.2163C4.74535 0.431444 3.28959 0.0196002 1.80557 0.0296682C1.36973 0.0314365 0.934803 0.0691433 0.50529 0.142398C0.364601 0.166414 0.237195 0.23938 0.146015 0.348155C0.0548356 0.45693 0.00587492 0.594365 0.00795039 0.735711V7.85548C0.00666709 7.94265 0.0248037 8.02904 0.0610699 8.10849C0.0973361 8.18794 0.15084 8.2585 0.217776 8.31514C0.284711 8.37179 0.363433 8.41314 0.44834 8.43624C0.533246 8.45933 0.622251 8.46362 0.70902 8.44879C1.56769 8.30158 2.44743 8.326 3.29643 8.52063C4.14542 8.71525 4.94649 9.07613 5.65246 9.58202L5.72437 9.62355H5.79028C5.85673 9.65097 5.92801 9.66508 6 9.66508C6.07199 9.66508 6.14327 9.65097 6.20972 9.62355H6.27563L6.34754 9.58202C7.04858 9.06482 7.84736 8.69225 8.69651 8.48638C9.54567 8.28051 10.4279 8.24553 11.291 8.38352C11.3777 8.39836 11.4668 8.39407 11.5517 8.37097C11.6366 8.34787 11.7153 8.30653 11.7822 8.24988C11.8492 8.19323 11.9027 8.12267 11.9389 8.04322C11.9752 7.96378 11.9933 7.87739 11.992 7.79021V0.670447C11.9858 0.535263 11.9331 0.406251 11.8426 0.30481C11.7522 0.20337 11.6294 0.135597 11.4947 0.112732ZM5.40079 7.99787C4.2922 7.42039 3.05821 7.119 1.80557 7.11977C1.60783 7.11977 1.41009 7.11977 1.20636 7.11977V1.18663C1.40593 1.17524 1.606 1.17524 1.80557 1.18663C3.0839 1.18523 4.33434 1.55667 5.40079 2.25459V7.99787ZM10.7936 7.1435C10.5899 7.1435 10.3922 7.1435 10.1944 7.1435C8.94179 7.14273 7.7078 7.44412 6.59921 8.0216V2.25459C7.66566 1.55667 8.9161 1.18523 10.1944 1.18663C10.394 1.17524 10.5941 1.17524 10.7936 1.18663V7.1435ZM11.4947 9.60575C11.0652 9.5325 10.6303 9.49479 10.1944 9.49302C8.70743 9.49182 7.25143 9.91402 6 10.7093C4.74857 9.91402 3.29257 9.49182 1.80557 9.49302C1.36973 9.49479 0.934803 9.5325 0.50529 9.60575C0.42729 9.61801 0.352507 9.64541 0.28524 9.68639C0.217973 9.72736 0.15955 9.7811 0.113331 9.84451C0.0671111 9.90792 0.0340071 9.97975 0.0159221 10.0559C-0.00216293 10.132 -0.00487207 10.2109 0.00795039 10.2881C0.0384012 10.4421 0.129284 10.578 0.260689 10.6658C0.392095 10.7537 0.55331 10.7864 0.70902 10.7568C1.56769 10.6096 2.44743 10.634 3.29643 10.8286C4.14542 11.0232 4.94649 11.3841 5.65246 11.89C5.75394 11.9616 5.87542 12 6 12C6.12458 12 6.24606 11.9616 6.34754 11.89C7.05351 11.3841 7.85458 11.0232 8.70357 10.8286C9.55257 10.634 10.4323 10.6096 11.291 10.7568C11.4467 10.7864 11.6079 10.7537 11.7393 10.6658C11.8707 10.578 11.9616 10.4421 11.992 10.2881C12.0049 10.2109 12.0022 10.132 11.9841 10.0559C11.966 9.97975 11.9329 9.90792 11.8867 9.84451C11.8404 9.7811 11.782 9.72736 11.7148 9.68639C11.6475 9.64541 11.5727 9.61801 11.4947 9.60575Z',
    })
  );
});
RecipesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
RecipesIcon.displayName = 'RecipesIcon';
export default RecipesIcon;
